/**
 * Dựng 1 dòng sản phẩm của phiếu Xuất kho / Chuyển kho từ 1 dòng đã qua `stock-slips/valid-data-import`
 * (ImportExcelStockSlip emit `validData`, giữ nguyên field BE). Dùng chung cho AddEStock + AddTransferStock để
 * 2 màn không lệch field: trước đây màn Chuyển kho tự dựng object và rơi mất lô → phiếu "Lưu và duyệt" không
 * có lô, tồn vật lý chuyển nhưng tồn lô đứng yên (t100730).
 *
 * `isBatchStockProduct` lấy từ BE (attachBatchStockFlag — theo DANH MỤC, cùng nguồn với ô tìm SP), KHÔNG suy
 * từ việc dòng có lô: phiếu xuất loại khác (Thất thoát/Thanh lý…) không resolve lô lúc import, dòng SP lô vẫn
 * phải hiện ô chọn lô.
 *
 * @param {Object} element dòng BE trả về sau khi validate import
 * @returns {Object} dòng của listProductStock
 */
export const toStockSlipItemFromImport = (element) => ({
  id: element.id,
  name: element.productName,
  productCode: element.productCode,
  barCode: element.barCode,
  totalQuantityInStock: element.totalQuantityInStock,
  IMEI: element.imeiCode,
  proId: element.productId,
  price: element.unitPrice,
  quantity: element.quantity,
  discount: element.discountAmount,
  totalPrice: element.totalAmount,
  productType: element.productType,
  productBatchStockId: element.productBatchStockId,
  productBatchStockCode: element.productBatchStockCode,
  isBatchStockProduct: Boolean(element.isBatchStockProduct),
  status: element.status,
});

/**
 * Thêm các dòng import vào danh sách phiếu. Gộp CHỈ khi trùng cả SP lẫn lô (mirror `onSelectedProduct`) —
 * 2 dòng cùng lô tách rời thì mỗi dòng qua kiểm tồn lô riêng, cộng lại vượt tồn và tới lúc duyệt mới báo lỗi.
 * Dòng không lô (IMEI / SP ngoài danh mục / SP lô chưa chọn lô) luôn thêm mới.
 * Sửa trực tiếp `listProductStock` (mảng reactive của màn).
 *
 * @param {Object[]} listProductStock danh sách dòng hiện có của phiếu
 * @param {Object[]} importedRows dòng ImportExcelStockSlip emit
 */
export const mergeImportedStockSlipItems = (listProductStock, importedRows = []) => {
  importedRows.forEach((element) => {
    const item = toStockSlipItemFromImport(element);
    const existed =
      item.productBatchStockId &&
      listProductStock.find(
        (row) =>
          row.proId === item.proId &&
          row.productBatchStockId === item.productBatchStockId,
      );
    if (existed) {
      existed.quantity = Number(existed.quantity) + Number(item.quantity);
    } else {
      listProductStock.push(item);
    }
  });
};
